import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import useReveal from '../hooks/useReveal';

function Card({ t, index }) {
  const { ref, inView } = useReveal();
  const initials = t.name.split(' ').map((w) => w[0]).join('').slice(0, 2);
  return (
    <div ref={ref} style={{ animationDelay: `${index * 80}ms` }} className={`reveal ${inView ? 'in-view' : ''} bg-white rounded-2xl border border-slate-100 shadow-sm p-6 card-hover`}>
      <Quote className="w-8 h-8 text-primary/20" />
      <div className="flex gap-0.5 mt-3">
        {Array.from({ length: t.rating }).map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
        ))}
      </div>
      <p className="mt-3 text-slate-700 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
      <div className="mt-5 flex items-center gap-3 pt-4 border-t border-slate-100">
        <div className="w-11 h-11 rounded-full bg-primary/10 text-primary font-bold flex items-center justify-center font-display">{initials}</div>
        <div>
          <div className="font-semibold text-slate-900">{t.name}</div>
          <div className="text-sm text-muted-foreground">{t.role}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-primary font-semibold uppercase tracking-wider text-sm">Testimonials</span>
          <h2 className="mt-2 text-3xl lg:text-4xl font-extrabold text-slate-900 font-display">What Our Clients Say</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <Card key={t.name} t={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
